<div *ngIf="order">
    <div class="card">
        <div class="order-header">
            <div class="order-header__actions d-flex">
                <a routerLink="/account/orders" class="btn btn-xs btn-secondary m-2" *ngIf="userDetails">{{"back_to_list"|translate}}</a>
                <a [href]="printOrder()" class="btn btn-xs btn-secondary m-2" target="_blank" *ngIf="userDetails">{{"print_order"|translate}}</a>
                <a *ngIf="(order.companyData?.benefitPay?.iban || order.companyData?.benefitPay?.phone) && order?.companyData?.showBenefitPay && order?.paidStatus=='np' && userDetails" (click)="payWithBenefit()" class="btn btn-xs btn-secondary ms-2">{{"pay_with_benefit"|translate}}</a>
                <a class="m-2 btn btn-xs btn-primary" *ngIf="order?.can?.cancel == true  && userDetails" (click)="openCancelDialog()">{{(order?.orderStatusData?.code == 'N'?
                    "cancel_order":'request_cancel')|translate}}</a>
                <a class="m-2 btn btn-xs btn-primary" *ngIf="order?.can?.return == true  && userDetails" (click)="openReturnDialog()">{{'request_return'|translate}}</a>
            </div>
            <h5 class="order-header__title">{{"order"|translate}} #{{ order?.orderId }} 
                
            </h5>
            <div class="order-header__subtitle">
                {{"created_at"|translate}} <mark class="order-header__date">{{ order?.orderDate |date:'medium' }}</mark>
                {{"order_status"|translate}} <mark class="order-header__status">{{ (order?.orderStatusData) ?
                    order?.orderStatusData?.name?.en : '' }}</mark>.
            </div>
            <div class="order-header__subtitle">
                {{"company"|translate}} <mark class="order-header__status">{{ (order?.companyData?.name) ?
                    translateHelper.localize(order?.companyData?.name) : '' }}</mark>.
            </div>
            <mat-divider *ngIf="order?.cancellation?.status" class="border-gray-400 w-1/3 min-w-64 mt-2"></mat-divider>
            <div class="text-sm" *ngIf="order?.cancellation?.status"> {{"cancel_order"|translate}}:</div>
            <div class="request-sent" *ngIf="order?.cancellation?.status == 'requested'">{{ "request_cancellation_sent"
                | translate }}.</div>
            <div class="request-approved" *ngIf="order?.cancellation?.status == 'approved'">{{
                "request_cancellation_approved" | translate }}.</div>
            <div class="request-sent" *ngIf="order?.cancellation?.status == 'rejected'">{{
                "request_cancellation_rejected" | translate }}</div>
            <div *ngIf="order?.cancellation?.response?.timestamp" class="text-sm">{{"response_date"|translate}} {{
                order?.cancellation?.response?.timestamp |date:'medium' }}</div>
            <div class="text-sm" *ngIf="order?.cancellation?.response?.note"> {{"cancel_response_note"|translate}}: {{
                order?.cancellation?.response?.note }}</div>

            <mat-divider *ngIf="order?.return?.status" class="border-gray-400 w-1/3 min-w-64 mt-2"></mat-divider>
            <div class="text-sm" *ngIf="order?.return?.status"> {{"return_request"|translate}}:</div>
            <div class="request-sent" *ngIf="order?.return?.status == 'requested'">{{ "request_return_sent" | translate
                }}.</div>
            <div class="request-approved" *ngIf="order?.return?.status == 'approved'">{{ "request_return_progressed" |
                translate }}.</div>
            <div class="request-sent" *ngIf="order?.return?.status == 'rejected'">{{ "request_return_rejected" |
                translate }}</div>
            <div *ngIf="order?.return?.response?.timestamp" class="text-sm">{{"response_date"|translate}} {{
                order?.return?.response?.timestamp |date:'medium' }}</div>
            <div class="text-sm" *ngIf="order?.return?.response?.note"> {{"cancel_request_note"|translate}}: {{
                order?.return?.response?.note }}</div>

            <app-return-order-information *ngIf="order?.return" [returnData]="order?.return">
            </app-return-order-information>
            <app-cancel-order-information *ngIf="order?.cancellation" [cancelData]="order?.cancellation">
            </app-cancel-order-information>

        </div>
        <div class="card-divider"></div>
        <div class="card-table">
            <div class="table-responsive-sm">
                <table>
                    <thead>
                        <tr>
                            <th>{{"product"|translate}}</th>
                            <th>{{"total"|translate}}</th>
                        </tr>
                    </thead>
                    <tbody class="card-table__body card-table__body--merge-rows">
                        <ng-container *ngFor="let item of order.items">
                            <tr>
                                <td>{{ translateHelper.localize(item.product?.name)}} × {{ item.amount }}

                                
                                        <div class="mt-2 booking-meta" style="display:flex;flex-direction:column;gap:0.5rem;align-items:flex-start;">
                                            <!-- Booking number: small muted text, aligned with product -->
                                            <ng-container *ngIf="item.bookingNumber">
                                                <small class="text-muted">
                                                    {{ "booking" | translate }}:
                                                    <a class="ms-1" [routerLink]="['/account/bookings']">#{{ item?.bookingNumber }}</a>
                                                </small>
                                            </ng-container>
                                            <!-- Quotation: render as inline link (or -- if missing) -->
                                            <ng-container *ngIf="item.rfqId; else rfqMissing">
                                                <small class="text-muted">
                                                    {{ "quotation_number" | translate }}:
                                                    <a [routerLink]="['/rfq/response', item.rfqId]" class="ms-1 booking-link">
                                                        #{{ item?.rfqId }}
                                                    </a>
                                                </small>
                                            </ng-container>
                                            <ng-template #rfqMissing>
                                                <small class="text-muted">--</small>
                                            </ng-template>
                                        </div>
                                            
                                        

                                

                                    <div class="mx-4" *ngIf="item.serviceData">
                                        <app-booking-details [serviceData]="item.serviceData" [dateType]="item.product?.dateType" [timeType]="item.product?.timeType">
                                        </app-booking-details>
                                    </div>
                                    <div *ngIf="item.options?.length > 0||item.variant" class="order-list__options">
                                        <app-options-details [options]="item.options" [variant]="item.variant"></app-options-details>
                                    </div>
                                    <div *ngIf="item.product.items?.length > 0" class="order-list__options">
                                        <ul class="order-list__options-list">
                                            <li *ngFor="let product of item.product.items" class="order-list__options-item">
                                                <span class="order-list__options-value">{{
                                                    translateHelper.localize(product.product.name) }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                                <td>{{ item.total|currencyConvert : order?.currencyMeta?.code }}</td>
                            </tr>
                            <tr *ngFor="let freeItem of item.free" class="free-item">
                                <td>--- {{ translateHelper.localize(freeItem.name)}} × {{ freeItem.amount }} </td>
                                <td>{{ 'free'|translate }}</td>
                            </tr>
                        </ng-container>


                    </tbody>
                    <tbody *ngIf="order.additionalLines?.length > 0" class="card-table__body card-table__body--merge-rows">
                        <tr>
                            <th>{{"subtotal"|translate}}</th>
                            <td>{{ order.subtotal|currencyConvert : order?.currencyMeta?.code }}</td>
                        </tr>
                        <tr *ngFor="let line of order.additionalLines">
                            <th>{{ line.label }}</th>
                            <td>{{ line.total|currencyConvert : order?.currencyMeta?.code }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="justify-end mb-2 me-2 sm:flex flex-row">
            <div class="float-left ms-3 sm:items-start me-2 font-bold">
                <div>{{"subtotal"|translate}}:</div>
                <div *ngIf="order.discountTotal">{{"discount"|translate}}:</div>
                <div>{{"shipping"|translate}}: </div>
                <div *ngIf="order.taxTotal">{{"tax"|translate}}:</div>
                <div>{{"total"|translate}}:</div>
            </div>
            <div class="float-right sm:items-end">
                <div>{{ order?.subtotal|currencyConvert : order?.currencyMeta?.code }}</div>
                <div *ngIf="order.discountTotal">{{ order?.discountTotal|currencyConvert : order?.currencyMeta?.code }}</div>
                <div>{{ order?.shippingTotal|currencyConvert : order?.currencyMeta?.code }}</div>
                <div *ngIf="order.taxTotal">{{ order?.taxTotal|currencyConvert : order?.currencyMeta?.code }}</div>
                <div>{{ order?.total|currencyConvert : order?.currencyMeta?.code }}</div>
            </div>
        </div>
    </div>

    <mat-tab-group dynamicHeight (selectedIndexChange)="selectedChange($event)">
        <mat-tab label="Details">
            <div *ngIf="order.shippingAddress" class="row mt-3 no-gutters mx-n2">
                <div class="col-sm-6 col-12 px-2">
                    <div class="card address-card address-card--featured">
                        <div class="address-card__body">
                            <div class="address-card__badge address-card__badge--muted">{{"shipping_address"|translate}}</div>
                            <div class="address-card__name">{{ order.shippingAddress.name}}</div>
                            <div class="address-card__row">
                                {{ order.shippingAddress.country }}<br>
                                <!-- {{ order.shippingAddress.postcode }}, --> {{ order.shippingAddress.city }}<br>
                                {{ order.shippingAddress.address }}
                            </div>
                            <div class="address-card__row">
                                <div class="address-card__row-title">{{"phone"|translate}}</div>
                                <div class="address-card__row-content">{{ order.shippingAddress.phone }}</div>
                            </div>
                            <div class="address-card__row">
                                <div class="address-card__row-title">{{"email_address"|translate}}</div>
                                <div class="address-card__row-content">{{ order?.userData?.email || order?.email }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-12 px-2 mt-sm-0 mt-3">
                    <div class="card address-card address-card--featured">
                        <div class="address-card__body">
                            <div class="address-card__badge address-card__badge--muted">{{"billing_address"|translate}}</div>
                            <div class="address-card__name">
                                {{ order.billingAddress.name}}</div>
                            <div class="address-card__row">
                                {{ order.billingAddress.country }}<br>
                                <!--  {{ order.billingAddress.postcode }}, --> {{ order.billingAddress.city }}<br>
                                {{ order.billingAddress.address }}
                            </div>
                            <div class="address-card__row">
                                <div class="address-card__row-title">{{"phone"|translate}}</div>
                                <div class="address-card__row-content">{{ order.billingAddress.phone }}</div>
                            </div>
                            <div class="address-card__row">
                                <div class="address-card__row-title">{{"email_address"|translate}}</div>
                                <div class="address-card__row-content">{{ order?.userData?.email || order?.email }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-3 no-gutters mx-n2">
                <div *ngIf="order?.orderPayments?.length > 0 && !order?.orderConfirmation" class="col-sm-6 col-12 px-2">
                    <div class="card address-card address-card--featured">
                        <div class="address-card__body">
                            <div class="address-card__badge address-card__badge--muted">{{"payment_details"|translate}}</div>
                            <div class="address-card__row">
                                <div class="address-card__row-title">{{"payment_type"|translate}}</div>
                                <ng-container *ngFor="let payment of order?.orderPayments">
                                    <div class="address-card__row-content">{{payment.type}}</div>
                                </ng-container>
                            </div>
                            <div class="address-card__row">
                                <div class="address-card__row-title">{{"paid_status"|translate}}</div>
                                <div class="address-card__row-content">{{paidStatuses[order?.paidStatus] || paidStatuses['np']}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="order?.groups?.length > 0" class="col-sm-6 col-12 px-2  mt-sm-0 mt-3">
                    <div class="card address-card address-card--featured">
                        <div class="address-card__body">
                            <div class="address-card__badge address-card__badge--muted">
                                {{"shipping_details"|translate}}</div>
                            <div *ngFor="let group of order.groups;let i=index; let last=last" class="address-card__row">
                                <div class="address-card__row-title">
                                    {{"shipped_products"|translate}} :
                                    <p class="font-bold" *ngFor="let item of groupProducts[i]">{{item.name.en}}
                                    </p>
                                </div>
                                <div class="address-card__row-title"> {{"shipping_method"|translate}}:</div>
                                <div class="address-card__row-content">{{group.shipping?.title?.en}} -
                                    {{group.shipping?.totalTaxed|currencyConvert : order?.currencyMeta?.code}}</div>
                                <hr *ngIf="!last">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3 no-gutters mx-n2">
                <div *ngIf="order?.promotions?.length > 0 ||  order?.vouchers?.length > 0 " class="col-sm-6 col-12 px-2 mt-sm-0 mt-3">
                    <div class="card address-card address-card--featured">
                        <div class="address-card__body">
                            <div class="address-card__badge address-card__badge--muted">{{"promotions"|translate}}</div>

                            <div class="address-card__row" *ngFor="let promotion of order?.promotions">
                                <div class="address-card__row-title promotion">{{promotion.title.en}}</div>
                                <div class="address-card__row-content">{{"total_discounted"|translate}}:{{promotion.total}}
                                </div>
                            </div>
                            <div *ngIf=" order?.vouchers?.length > 0" class="address-card__row">
                                <div class="address-card__row-title">{{"applied_coupons_vouchers"|translate}}</div>
                                <ng-container *ngFor="let coupon of order.appliedCoupons">
                                    <div class="address-card__row-content">{{coupon}}</div>
                                </ng-container>
                                <ng-container *ngFor="let vouchers of order.vouchers">
                                    <div class="address-card__row-content">{{vouchers.code}} - {{"paid_total"|translate}}:
                                        {{vouchers.total|currencyConvert : order?.currencyMeta?.code}}</div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="order?.statusLog?.length > 0" class="col-sm-6 col-12 px-2 mt-sm-0 mt-3">
                    <div class="card address-card address-card--featured">
                        <div class="address-card__body">
                            <div class="address-card__badge address-card__badge--muted">{{"status"|translate}}</div>

                            <div class="address-card__row" *ngFor="let log of order?.statusLog">
                                <div class="address-card__row-title promotion">{{log.status}}</div>
                                <div class="address-card__row-content">{{"date"|translate}}:{{log.date|date:"short"}}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </mat-tab>
        <mat-tab *ngIf="siteService.features?.orderMessages">
            <ng-template mat-tab-label>
                <span [matBadge]="order?.unreadUserMessages? '*':null" matBadgeColor="warn" matBadgeOverlap="false">Messages</span>
            </ng-template>
            <div class="card">
                <app-order-messages [order]="order"></app-order-messages>
            </div>
        </mat-tab>
    </mat-tab-group>



</div>